module.exports = __webpack_public_path__ + "static/media/de.a2ff6d85.svg";